import { useState } from "react";

import { faArrowLeftLong, faSave } from "@fortawesome/pro-regular-svg-icons";
import { NavLink } from "react-router-dom";

import { Button } from "src/base-components/Button";
import { Icon } from "src/base-components/Icon";
import { TitleEditor } from "src/base-components/TitleEditor";
import { FeatureCatalogueWrapper } from "src/featureCatalogue/FeatureCatalogue";
import { LayoutHeader } from "src/layout/Header";
import { PageHeader } from "src/layout/PageHeader";
import { DashboardPageParams, getUrlToFeaturesPage } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const ManageFeatureQueryPage = () => {
  const [title, setTitle] = useState("Untitled Feature Query");
  const { orgId, wsId } = useParamsDecode<DashboardPageParams>();
  return (
    <FeatureCatalogueWrapper
      breadcrumbs={[
        {
          key: "back-to-queries",
          breadcrumb: (
            <PageHeader.Breadcrumb hideIcon>
              <NavLink
                data-loc="back-to-queries"
                to={getUrlToFeaturesPage(orgId, wsId)}
              >
                <Icon icon={faArrowLeftLong} size="xs" />
              </NavLink>
              <TitleEditor
                className="font-inter-semibold-13px"
                value={title}
                onSubmit={setTitle}
              />
            </PageHeader.Breadcrumb>
          ),
        },
        {
          key: "create-feature-query",
          breadcrumb: (
            <LayoutHeader.Breadcrumb>
              <></>
              {/* Version Picker component */}
            </LayoutHeader.Breadcrumb>
          ),
        },
      ]}
      headerSideContent={
        <div className="flex gap-x-3">
          <Button variant="secondary">Test</Button>
          <Button iconLeft={faSave} variant="secondary">
            Save
          </Button>
          <Button>Deploy</Button>
        </div>
      }
      showSubHeader={false}
    >
      <></>
    </FeatureCatalogueWrapper>
  );
};
